import { useRef } from 'react';
import { AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogFooter } from '@chakra-ui/react';
import { useConfirm } from 'contexts';
import { AlertDialogHeader, Button } from 'components/UI';
import { AlertDialogBody } from 'components/UI/AlertDialogBody';

const Confirm = () => {
  const [setShowConfirm, showConfirm] = useConfirm();
  const cancelRef = useRef<HTMLButtonElement>(null);

  if (!showConfirm) return null;

  const {
    onConfirm = () => {},
    onCancel = () => {},
    confirmText = 'CONFIRM',
    cancelText = 'CANCEL',
    message,
    title,
  } = showConfirm;

  const handleClose = () => {
    onCancel();
    setShowConfirm(null);
  };

  return (
    <AlertDialog
      isOpen={!!showConfirm}
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={handleClose}
      onEsc={handleClose}
      size="2xl"
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent pt={3} pb={5}>
          <AlertDialogHeader textAlign="center" pb={1.5}>
            {title}
          </AlertDialogHeader>

          <AlertDialogBody textAlign="center">{message}</AlertDialogBody>

          <AlertDialogFooter gap={3} justifyContent="center" py={4} mt={1.5}>
            <Button ref={cancelRef} py={2.5} onClick={handleClose}>
              {cancelText}
            </Button>
            <Button
              py={2.5}
              onClick={() => {
                setShowConfirm(null);
                onConfirm();
              }}
            >
              {confirmText}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};

export { Confirm };
